import React from "react"
import PropTypes from "prop-types"

const Nl2Br = ({ children }) => {
  const string = children || ""
  return (
    <span className="ww-bw wb-bw hy-a">
      {string.split("\n").map((item, key) => (
        <span key={key}>
          {item}
          <br />
        </span>
      ))}
    </span>
  )
}
Nl2Br.propTypes = {
  children: PropTypes.node,
}

export default Nl2Br
